module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-LightItalic.woff?5c1fed577067d3ef512f2e84ce84ac1b";